<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="isNew" translate="NEW_ITEM"></ion-title>
    <ion-title *ngIf="!isNew">Item <span *ngIf="item" [innerText]="'- ' + item?.name"></span></ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize" (click)="onSaveClick()" translate="SAVE"></ion-button>
      <ion-button class="ion-text-capitalize" (click)="onCloseClick()" translate="CLOSE"></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="banner">
    <!-- Thumbnail if image exists -->
    <div
      class="thumbnail"
      *ngIf="item?.iconImage?.url"
      [style.background-image]="'url(' + item.iconImage.url + ')'">
      <div class="change-overlay" (click)="fileDropRef.click()">
        <ion-icon name="camera-outline"></ion-icon>
        <span>Change Image</span>
      </div>
      <input
        type="file"
        #fileDropRef
        style="display: none"
        (change)="onImageSelection($event)"
        accept="image/png, image/gif, image/jpeg"
      />
    </div>

    <!-- Show uploader only if image not selected -->
    <div class="image-upload-wrapper" *ngIf="!item?.iconImage?.url">
      <div class="image-upload-bg">
        <div class="image-upload" sdDnd (fileDropped)="onImageSelection($event)">
          <input
            type="file"
            #fileDropRef
            id="fileDropRef"
            (change)="onImageSelection($event)"
            accept="image/png, image/gif, image/jpeg"
          />
          <ion-icon src="assets/icons/file_upload_black_24dp.svg"></ion-icon>
          <h3>Drag and drop file here <strong>or</strong></h3>
          <label for="fileDropRef" class="browse-btn">Browse for file</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Form -->
  <form [formGroup]="form" class="smartdine-form">
    <ion-list>

      <ion-item lines="inset">
        <ion-label>
          <span translate="ITEM_NAME"></span><span class="required-star">*</span>
        </ion-label>
        <ion-input formControlName="name" placeholder="Enter item name"></ion-input>
      </ion-item>
      <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid" class="error-text">
        Item name is required.
      </small>

      <ion-item lines="inset">
        <ion-label translate="DESCRIPTION"></ion-label>
        <ion-input formControlName="description" placeholder="Enter description"></ion-input>
      </ion-item>

      <ion-item lines="inset">
        <ion-label>
          <span translate="TEMPLATE"></span><span class="required-star">*</span>
        </ion-label>
        <ion-toggle slot="end" formControlName="template"></ion-toggle>
      </ion-item>

      <ion-item lines="inset">
        <ion-label>
          <span translate="VEGETARIAN"></span><span class="required-star">*</span>
        </ion-label>
        <ion-toggle slot="end" formControlName="vegetarian"></ion-toggle>
      </ion-item>

      <ion-item lines="inset">
        <ion-label>
          <span translate="ITEM_TYPE"></span><span class="required-star">*</span>
        </ion-label>
        <ion-select formControlName="itemType" slot="end" placeholder="Select Item Type">
          <ion-select-option value="FOOD">Food</ion-select-option>
          <ion-select-option value="LIQUOR">Liquor</ion-select-option>
          <ion-select-option value="FOOD_5">FOOD_5</ion-select-option>
          <ion-select-option value="FOOD_12">FOOD_12</ion-select-option>
          <ion-select-option value="FOOD_18">FOOD_18</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item lines="inset">
        <ion-label translate="TAGS"></ion-label>
        <ion-select multiple formControlName="tags" slot="end" placeholder="Select Tags">
          <ion-select-option>Veg</ion-select-option>
          <ion-select-option>Egg</ion-select-option>
          <ion-select-option>Non Veg</ion-select-option>
          <ion-select-option>Beverage</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item lines="inset">
        <ion-label class="form-label">Select Type</ion-label>
        <ion-radio-group formControlName="quantityItemType" (ionChange)="onItemTypeChange($event)" slot="end">
          <ion-item class="radio mx-1">
            <ion-radio slot="start" value="quantity"></ion-radio>
            <ion-label>Quantity</ion-label>
          </ion-item>
          <ion-item class="radio mx-1">
            <ion-radio slot="start" value="specialization"></ion-radio>
            <ion-label>Specialization</ion-label>
          </ion-item>
        </ion-radio-group>
      </ion-item>
      
      <div formGroupName="itemQuantity">
        <ion-item *ngIf="!isQuantitySelected" lines="inset">
          <ion-label>Specialization</ion-label>
          <ion-select formControlName="value" slot="end" placeholder="Select specialization">
            <ion-select-option *ngFor="let spec of specializations" [value]="spec">{{ spec }}</ion-select-option>
          </ion-select>
        </ion-item>
      
        <ion-item *ngIf="isQuantitySelected" lines="inset">
          <ion-label>Quantity</ion-label>
          <ion-input formControlName="value" placeholder="Enter quantity"></ion-input>
        </ion-item>
      
        <ion-item lines="inset">
          <ion-label>Measurement</ion-label>
          <ion-select formControlName="measurementUnit" slot="end" placeholder="Select unit">
            <ion-select-option>HALF</ion-select-option>
            <ion-select-option>FULL</ion-select-option>
            <ion-select-option>SMALL</ion-select-option>
            <ion-select-option>LARGE</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      

    </ion-list>
  </form>
</ion-content>
